import {imageUri} from "@/utils/settings";

function getAnimatedSprite(pokedexId, shiny=false, back=false) {
    const folder = (back ? 'back' : 'front') + (shiny ? '-shiny' : '') + '/';
    return imageUri + 'static/pokedex/sprites/' + folder + pokedexId + '.gif';
}

export {
    getAnimatedSprite
};